import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { isThankYouLotto } from '../../../../utils/template';
import { PRIMARY_NUMBERS, BONUS_NUMBERS } from '../../helpers/linesHelper';
import useLinesHelper from '../../helpers/useLinesHelper';

export default function NumberPanelTitle() {
    const { t } = useTranslation();
    const { lottery, numbersPerLine, isBonusNumberPickable } = useLinesHelper();

    const isMegaJackpot = useMemo(() => lottery?.display_slug?.startsWith('mega-jackpot'), []);
    const isTemplateThankYouLotto = useMemo(() => isThankYouLotto(), []);
    const haveBonusNumbers = useMemo(() => numbersPerLine[BONUS_NUMBERS] && isBonusNumberPickable(lottery), []);

    if (!haveBonusNumbers || isTemplateThankYouLotto) {
        return <>{t('playPicker.pickNNumbers', { numbersToPick: numbersPerLine[PRIMARY_NUMBERS] })}</>;
    }

    if (isMegaJackpot) {
        return (
            <>
                {t('playPicker.lottery.pickNumbersAnd', { count: numbersPerLine[PRIMARY_NUMBERS] })}{' '}
                {t('playPicker.lottery.extraNumber', { count: numbersPerLine[BONUS_NUMBERS] })}
            </>
        );
    }

    return (
        <>
            {t('playPicker.lottery.pickNumbersAnd', { count: numbersPerLine[PRIMARY_NUMBERS] })}{' '}
            <span className="d-inline-block">
                {t('playPicker.lottery.bonusNumber', {
                    count: numbersPerLine[BONUS_NUMBERS],
                    name: lottery.bonusNumberName,
                })}
            </span>
        </>
    );
}
